import React from "react";
import CustomButton from "../custom-button";

const SurveySplashCarouselCard = ({
  id,
  orientation,
  children,
  active,
  lastCard,
  showParticipantsFooter = false,
  onClickStart,
}) => {
  const randNumber = parseInt(1 + Math.random() * (8 - 1));

  const renderNavigationButtons = () => {
    if (lastCard) {
      return <CustomButton onClick={onClickStart} color="white" text="Comenzar" icon="play" />;
    }

    return (
      <a href={`#${id}`} data-slide="next">
        <CustomButton color="white" text="Siguiente" icon="chevron-right" />
      </a>
    );
  };

  return (
    <div className={`carousel-item ${active && "active"}`}>
      <div
        className={`postcard dark blue ${orientation === "left" ? "image-left" : "image-right"}`}
      >
        <img
          className="postcard__img"
          alt="UlagosCampus"
          src={require(`../../assets/img/splash_images/${randNumber}.jpg`).default}
        />
        <div className="postcard__text">
          {children}
          <span className="text-right">{renderNavigationButtons()}</span>
          {showParticipantsFooter && (
            <footer className="postcard__footer">
              <h6>
                <i>
                  Participan: P. Universidad Católica de Chile, Universidad Alberto Hurtado,
                  Universidad Arturo Prat, Universidad Católica de la Santísima Concepción,
                  Universidad Católica de Temuco, Universidad Católica del Maule, Universidad de
                  Atacama, Universidad de Aysén, Universidad de Chile, Universidad de la Frontera,
                  Universidad de los Andes, Universidad de Los Lagos, Universidad de Magallanes,
                  Universidad de Playa Ancha, Universidad de Santiago de Chile, Universidad de
                  Talca, Universidad de Valparaíso, Universidad Metropolitana de Ciencias de la
                  Educación, y Universidad Tecnológica Metropolitana.
                </i>
              </h6>
              <h6>
                <i>
                  Patrocinan: Consejo de Rectores de las Universidades Chilenas (CRUCh) y Núcleo
                  Milenio de Experiencias de los Estudiantes de la Educación Superior (NMEdSup).
                </i>
              </h6>
            </footer>
          )}
        </div>
      </div>
    </div>
  );
};

export default SurveySplashCarouselCard;